import axios from 'axios';

// Auto-detect API base: in production use same origin, in dev override via .env
const API_BASE_URL =
  process.env.REACT_APP_API_URL ||
  (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'
    ? 'http://localhost:5000/api'
    : `${window.location.origin}/api`);

const API = axios.create({
  baseURL: API_BASE_URL,
});

// Skip-redirect flag (set via API.helpers.skipRedirect() during auth calls)
const skipRedirect = { current: false };

API.helpers = {
  /** Wrap a single API call so its 401 does NOT trigger the global page-redirect */
  skipRedirect: () => {
    skipRedirect.current = true;
    return () => { skipRedirect.current = false; };
  },
};

API.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

API.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const url = error.config?.url || '';

    // Only force-redirect for genuine session-expired cases
    // (NOT for login/register attempts where 401 means "bad credentials").
    const isAuthEndpoint =
      url.endsWith('/auth/login') ||
      url.endsWith('/auth/register') ||
      skipRedirect.current;

    if (status === 401 && !isAuthEndpoint) {
      // Token expired / invalid — kick the user to login but keep the page
      // tidy (silent sign-out) rather than reload and lose context.
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      // Use SPA navigation (not page reload) to avoid losing any in-flight UI state.
      // We import this lazily to avoid an import cycle with App/AuthProvider.
      if (typeof window !== 'undefined' && window.history && window.location.pathname !== '/login') {
        window.history.pushState({}, '', '/login');
        window.dispatchEvent(new PopStateEvent('popstate'));
      }
    }
    return Promise.reject(error);
  }
);

export default API;
